<template>
  <div class="batch-import-container">
    <div class="batch-row flex">
      <div class="batch-row__icon">
        <i class="iconfont icon-cloud-download-alt"></i>
      </div>
      <div class="batch-row__content">
        <div class="batch-row__title">填写导入数据信息</div>
        <div class="font12">请按照数据模版的格式准备导入数据，模版中的表头名称不可以更改，表头行不能删除</div>
        <div><a :href="href">下载模版</a><span class="font12">&nbsp;({{date}}更新)</span></div>
      </div>
    </div>
    <div class="batch-row flex">
      <div class="batch-row__icon">
        <i class="iconfont icon-cloud-upload-alt"></i>
      </div>
      <div class="batch-row__content">
        <div class="batch-row__title">上传填好的信息表</div>
        <div class="font12">文件后缀名必须为xls或xlsx（即Excel格式），文件大小不得大于10M，最多支持导入3000条数据</div>
        <div>
          <el-upload
            class="upload-demo"
            ref="upload"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            action="" :multiple="false" :limit="1"
            :file-list="fileList"
            :show-file-list="true"
            :on-change="fileChange"
            :on-exceed="handleExceed"
            :auto-upload="false">
            <el-button slot="trigger" type="text" size="large">上传文件</el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <el-alert
      title="操作提示"
      type="warning"
      description="" :closable="false"
      show-icon>
      1、请点击“下载模版”按钮，将导入模版存于本地；<br />
      2、根据模版填充信息后，点击“上传文件”选中文件上传；<br />
      3、新维护的被保人信息，需要在保单保存后再维护理赔信息；
    </el-alert>
  </div>
</template>

<script>
export default {
  name: 'yblBatchImport',
  props: {
    href: { // 模版地址
      type: String,
      default: '',
      required: true
    },
    date: { // 模版更新日期
      type: String,
      default: '2023.01.29',
      required: true
    }
  },
  data () {
    return {
      fileList: []
    }
  },
  methods: {
    fileChange (file, fileList) {
      // console.log('🚀 ~ file: batchImport.vue:69 ~ fileChange ~ fileList', fileList, file)
      if (file.size / (1024 * 1024) > 10) {
        this.$message({
          type: 'warning',
          message: '单次上传的文件不能超过10M'
        })
        const length = fileList.length
        fileList.splice(length - 1, 1)
      }
      this.fileList = fileList
      this.$emit('change', fileList)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    }
  }
}
</script>

<style lang="less">
@import url("../assets/less/color.less");
.batch-import-container{
  .flex{
    display:flex;
    align-items: center;
  }
  .batch-row{
    border: 1px solid @border-color;
    background-color: @border-color;
    &+.batch-row{
      margin: 15px 0;
    }
    &__title{
      font-weight: bold;
    }
    &__content{
      padding: 10px 10px;
      border-left: 1px solid @border-color;
      background-color: @white-color;
      width: 100%;
      line-height: 25px;
    }
    &__icon{
      padding: 0 25px;
    }
    .iconfont{
      font-size: 30px;
      color: darkgray;
    }
  }
  a{
    text-decoration: none;
    color: @color;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/batchImport.vue